<template>
  <!-- KP-3919 kill switch. OFF renders the modal exactly as it shipped
       before; ON renders the picker that can deliver brand-catalogue files
       alongside the order form. Both open on the same modal id, so callers
       are unaffected either way. -->
  <dowload-catalog-legacy
    v-if="!isBrandCatalogueEnabled"
    :collection="collection"
  />
  <div v-else>
    <!-- download collection modal -->
    <b-modal
      :id="`download_catalog_${collection._id}`"
      centered
      title="Download Collection"
      hide-footer
    >
      <!-- Shared picker — offer whatever this collection actually has,
           individually or as one structured ZIP. -->
      <collection-download-picker
        :collection="collection"
        :downloading="downloading"
        @download="downloadCatalogue"
        @close-popup="$bvModal.hide(`download_catalog_${collection._id}`)"
      />
    </b-modal>
  </div>
</template>
<script>
import { BModal, VBModal, VBTooltip } from 'bootstrap-vue'
import CollectionDownloadPicker from '@/components/collection/CollectionDownloadPicker.vue'
import DowloadCatalogLegacy from '@/views/apps/collection/DowloadCatalogLegacy.vue'
import { useCollectionDownload } from '@/composables/useCollectionDownload'
import { useBrandCatalogueFlag } from '@/composables/useBrandCatalogueFlag'

export default {
  name: 'DownloadCatalog',
  components: {
    BModal,
    CollectionDownloadPicker,
    DowloadCatalogLegacy,
  },
  directives: {
    'v-b-modal': VBModal,
    'b-tooltip': VBTooltip,
  },
  props: {
    collection: {
        type: Object,
        default() {
            return null
        },
    },
  },
  setup(props, { root }) {
    return {
      ...useCollectionDownload({
        collectionId: () => props.collection && props.collection._id,
        onWholeCollection: () => root.$bvModal.hide(`download_catalog_${props.collection._id}`),
      }),
      ...useBrandCatalogueFlag(),
    }
  },
}
</script>
<style lang="scss">
@import '~@core/scss/base/pages/app-ecommerce.scss';

</style>
